import React from 'react';
import { UserPlusIcon, UserCheckIcon, ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface Connection {
  id: number;
  name: string;
  role: string;
  location: string;
  avatar: string;
  matchPercentage: number;
  tags: string[];
  matchReason: string;
  connectionType: 'course' | 'connected' | 'both';
  isConnected: boolean;
}
interface BestMatchesWidgetProps {
  connections: Connection[];
}
const BestMatchesWidget: React.FC<BestMatchesWidgetProps> = ({
  connections
}) => {
  const topConnections = [...connections].sort((a, b) => b.matchPercentage - a.matchPercentage).slice(0, 3);
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full" data-id="element-664">
      <div className="p-5" data-id="element-665">
        <div className="flex items-center mb-4" data-id="element-666">
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-667">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-668" />
          </div>
          <div data-id="element-669">
            <h2 className="text-base font-semibold text-gray-800" data-id="element-670">
              Match Suggeriti
            </h2>
            <p className="text-xs text-gray-500" data-id="element-671">
              Powered by EIIS Intelligence
            </p>
          </div>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-672">
          {topConnections.map((connection, index) => <div key={connection.id} className="py-3 hover:bg-gray-50/50 transition-colors" data-id="element-673">
              <div className="flex items-center" data-id="element-674">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0" data-id="element-675">
                  <img src={connection.avatar} alt={connection.name} className="w-full h-full object-cover" data-id="element-676" />
                </div>
                <div className="ml-3 flex-1 min-w-0" data-id="element-677">
                  <div className="flex items-center justify-between" data-id="element-678">
                    <h3 className="text-sm font-medium text-gray-900 truncate" data-id="element-679">
                      {connection.name}
                    </h3>
                    <div className="text-sm font-medium text-custom-green" data-id="element-680">
                      {connection.matchPercentage}%
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-0.5 line-clamp-1" data-id="element-681">
                    {connection.matchReason}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default BestMatchesWidget;